<template>
  <div>
    <Header @getLanguageMap='getLanguageMap'></Header>
    <div class="crumbs">
      <div class="container">
        <p class="title">{{ languageMap['关于我们'] }}</p>
        <div class="childs"><a href="/#/">{{ languageMap['主页'] }}</a> &gt; <a
            href="/#/about/">{{ languageMap['关于我们'] }}</a> &gt;
        </div>
      </div>
    </div>
    <!-- <NavigationBar></NavigationBar> -->

    <div class="main">
      <div class="container">
        <div class="maxTitle"><span class="title">{{ languageMap['关于我们'] }}</span>
          <div class="sub"></div>
        </div>
        <div class="head">
          <div class="left">
            <img src="/templets/111/picture/1-151011130p1923.jpg" style="width: 590px; height: 250px;"></div>
          <div class="right">
            <p>
              {{ languageMap['明瑞系统进化论'] }}<br><br>
              {{ languageMap['对于LED显示领域的不断革新与发展，明瑞科技充满了热情，面对不断的创新调整，明瑞控制系统在不断的进化，不断的努力。'] }}<br><br>{{ languageMap['明瑞承诺为用户提供最佳的技术、产品、服务及解决方案。'] }}<br><br>{{ languageMap['明瑞相信客户的需求是我们的生存之本，客户的需求是我们进化之源。'] }}
            </p>
          </div>
        </div>
        <br>

        <div class="content">
          <!-- left -->
          <div class="left">
            <div class="contentTitle"><span class="title">{{ languageMap['明瑞科技'] }}</span>
              <div class="sub"></div>
            </div>

            <p class="info"></p>
            <p style="margin: 0px; padding: 0px; color: rgb(51, 51, 51); font-family: 'Microsoft YaHei', Tahoma, Verdana, Simsun; line-height: 24px;">
	<span
      style="font-size:16px;">{{ languageMap['明瑞科技建立于2013年，专注于LED灯光控制系统的开发与服务。明瑞科技自成立以来，以技术开发为主轴，以客户服务为根本，致力于城市照明与多媒体视频显示领域的创新和开发。'] }}<br
      style="font-size: 14px;">
	<br style="font-size: 14px;">
	{{ languageMap['明瑞科技在LED显示技术、计算机软件、多媒体技术及网络通讯技术等方面具有强大的实力。公司的研发团队在图形图像软件、多种单片机与ARM处理器、大型可编辑逻辑器件（FPGA、CPLD）具备突出能力，并成功研制多系列软硬件产品，投入市场后得到业内众多知名企业的肯定与支持。'] }}<br
        style="font-size: 14px;">
	<br style="font-size: 14px;">
	{{ languageMap['明瑞科技以客户服务为本，在技术服务团队中我们具备在LED显示领域和控制系统领域的资深专家，对照明控制行业有着深刻与独到的了解。'] }}<br
        style="font-size: 14px;">
	<br style="font-size: 14px;">
	{{ languageMap['明瑞控制系统具备超强的数据带载能力，稳定的远距离传输能力及工程布线灵活简捷等突出特点，兼容多种LED驱动芯片，兼容USITT DMX512/1990标准协议及扩展协议，可控制多种LED数码管、点光源、大功率灯具及多种复杂的异形灯具。'] }}<br
        style="font-size: 14px;">
	<br style="font-size: 14px;">
	{{ languageMap['明瑞控制系统在打造高品质产品同时，在整体城市互联网联动控制系统，超大型屏幕控制系统，脱机楼宇卫星同步系统及各种控制系统定制开发等方面可为用户提供整套的解决方案。'] }}<br
        style="font-size: 14px;">
	<br style="font-size: 14px;">
	{{ languageMap['明瑞科技立足于“创新”“品质”“服务”三大基石，竭诚为您提供高品质的产品和服务，以答谢客户对我们的信赖与支持。面对不断的挑战与机遇，明瑞科技愿携手广大同仁，共创美好未来。'] }}</span>
            </p>


            <p></p>
<!--            <div class="contentTitle"><span class="title" @click="relatedUrl">{{ languageMap['相关荣誉'] }}</span>-->
<!--              <div class="sub"></div>-->
<!--            </div>-->

          </div>
          <!-- left over -->
          <!-- right -->
          <div class="right">
            <div class="contentTitle"><span class="title">{{ languageMap['联系我们'] }}</span>
              <div class="sub"></div>
            </div>
            <form enctype="multipart/form-data" method="post">
              <input type="hidden" name="action" value="post">
              <input type="hidden" name="diyid" value="1">
              <input type="hidden" name="do" value="2">
              <p class="lineTitle">{{ languageMap['您的名字（必填）'] }}</p>
              <div class="line">
                <input type="text" name="name" class="inputText" v-model="from.name">
              </div>
              <p class="lineTitle">{{ languageMap['您的邮箱（必填）'] }}</p>
              <div class="line">
                <input type="text" name="email" class="inputText" v-model="from.email">
              </div>
              <p class="lineTitle">{{ languageMap['标题'] }}</p>
              <div class="line">
                <input type="text" name="bt" class="inputText" v-model="from.title">
              </div>
              <p class="lineTitle">{{ languageMap['内容'] }}</p>
              <div class="line">
                <textarea name="nr" class="textArea" v-model="from.content"></textarea>
              </div>
              <input type="hidden" name="dede_fields" value="name,text;email,text;bt,text;nr,text">
              <input type="hidden" name="dede_fieldshash" value="f34de0eba88646549ae2f733b3d2d519">
              <div class="line">
                <input class="inputSub" :value="languageMap['发送']" @click="contactUsAdd"
                       style="color: white !important;">
              </div>
            </form>
          </div>
          <!-- right over -->
        </div>

      </div>
    </div>


    <Footer></Footer>
  </div>
</template>

<style scoped>

.main .head {
  padding: 40px 0;
}

.main .head:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.main .head .left {
  width: 590px;
  height: 250px;
  float: left;
}

.main .head .left img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

.main .head .right {
  width: 500px;
  float: right;
  margin-right: 20px;
}

.main .head .right p {
  color: #666;
  font-size: 14px;
  line-height: 22px;
}

.main .content:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.main .content .contentTitle {
  position: relative;
  line-height: 28px;
}

.main .content .contentTitle span {
  position: relative;
  z-index: 1;
  color: #333333;
  font-size: 18px;
  background: #fff;
  padding-right: 12px;
}

.main .content .contentTitle .sub {
  position: absolute;
  top: 14px;
  left: 0px;
  height: 1px;
  background: #d6d6d6;
  width: 100%;
}

.main .content .left {
  width: 685px;
  float: left;
}

.main .content .left ul {
  margin: 18px 0;
  padding-left: 20px;
}

.main .content .left li {
  height: 28px;
  line-height: 28px;
  color: #666;
  font-size: 14px;
  list-style: disc;
}

.main .content .left .info {
  color: #666;
  font-size: 14px;
  line-height: 22px;
  margin: 18px 0;
}

.main .content .right {
  width: 445px;
  float: right;
}

.main .content .right .contentTitle {
  padding-bottom: 30px;
}

.main .content .right .lineTitle {
  padding-top: 14px;
  font-size: 14px;
  color: #666;
  line-height: 32px;
}

.main .content .right .inputText {
  color: #666;
  width: 354px;
  height: 36px;
  border: 1px solid #b8b8b8;
  background: #fff;
  padding-left: 12px;
}

.main .content .right .textArea {
  color: #666;
  width: 412px;
  height: 143px;
  padding: 12px;
  border: 1px solid #b8b8b8;
}

.main .content .right .inputSub {
  font-size: 14px;
  cursor: pointer;
  width: 90px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  background: #999;
  text-align: center;
  margin-top: 14px;
  border: 0;
}

.main .content .right .inputSub {
  transition-duration: .5s;
  -ms-transition-duration: .5s;
  -moz-transition-duration: .5s;
  -webkit-transition-duration: .5s;
}

.main .content .right .inputSub:hover {
  background: #717070;
}

.main .customer {
  position: relative;
  border-bottom: 1px solid #d6d6d6;
}

.main .customer .title {
  line-height: 36px;
  color: #333333;
  font-size: 18px;
  padding-bottom: 20px;
}

.main .customer .customerContent {
  position: relative;
  width: 100%;
  height: 290px;
  overflow: hidden;
}

.main .customer .customerContent .contents {
  position: absolute;
  top: 0px;
  left: 0px;
}

.main .customer .customerContent .child {
  position: absolute;
  top: 0;
  left: 0px;
  width: 566px;
  height: 290px;
}

.main .customer .customerContent .child .childContent {
  position: relative;
  width: 520px;
  height: 127px;
  padding: 24px;
  background-color: #f1f1f1;
}

.main .customer .customerContent .child .childContent p {
  color: #777777;
  font-size: 14px;
  line-height: 24px;
}

.main .customer .customerContent .child .childContent .pointer {
  position: absolute;
  bottom: -11px;
  height: 11px;
  left: 106px;
}

.main .customer .customerContent .child .childFoot {
  position: relative;
  height: 80px;
}

.main .customer .customerContent .child .childFoot .childIcon {
  float: left;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.main .customer .customerContent .child .childFoot .childIcon img {
  max-height: 80px;
  vertical-align: middle;
}

.main .customer .customerContent .child .childFoot .childInfo {
  float: left;
  padding-left: 20px;
}

.main .customer .customerContent .child .childFoot .childInfo .childTitle {
  color: #777777;
  font-size: 14px;
  line-height: 24px;
  padding-top: 15px;
}

.main .customer .customerContent .child .childFoot .childInfo .childEn {
  line-height: 22px;
  color: #939393;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
}

.main .customer .customerBtn {
  position: absolute;
  bottom: 54px;
  cursor: pointer;
  z-index: 1;
}

.main .customer .customerBtn.leftBtn {
  right: 50px;
}

.main .customer .customerBtn.rightBtn {
  right: 0px;
}

.main .customerLogo {
  position: relative;
  padding-top: 34px;
}

.main .customerLogo .title {
  line-height: 36px;
  color: #333333;
  font-size: 18px;
  padding-bottom: 36px;
}

.main .customerLogo .customerLogoContent {
  position: relative;
  height: 156px;
  width: 100%;
  overflow: hidden;
}

.main .customerLogo .customerLogoContent .contents {
  position: absolute;
  top: 0px;
  left: 0px;
}

.main .customerLogo .customerLogoContent .child {
  position: absolute;
  top: 0px;
  width: 222px;
  height: 154px;
  line-height: 154px;
  text-align: center;
  border: 1px solid #e2e2e2;
}

.main .customerLogo .customerLogoContent .child {
  transition-duration: .5s;
  -ms-transition-duration: .5s;
  -moz-transition-duration: .5s;
  -webkit-transition-duration: .5s;
}

.main .customerLogo .customerLogoContent .child:hover {
  -webkit-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  -ms-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
}

.main .customerLogo .customerLogoContent .child img {
  vertical-align: middle;
  max-width: 90%;
  max-height: 90%;
}

.main .customerLogo .logoBtn {
  position: absolute;
  top: 164px;
  cursor: pointer;
}

.main .customerLogo .logoBtn.leftBtn {
  left: -60px;
}

.main .customerLogo .logoBtn.rightBtn {
  right: -60px;
}

@media (max-width: 639px) {
  .main .head {
    padding: 20px 0;
  }

  .main .head .left {
    width: 100%;
    height: auto;
    float: none;
  }

  .main .head .left img {
    width: 100%;
    height: auto;
  }

  .main .head .right {
    width: 100%;
    float: none;
    margin: 10px 0;
  }

  .main .head .right p {
    font-size: 12px;
    line-height: 18px;
  }

  .main .content .contentTitle {
    line-height: 20px;
  }

  .main .content .contentTitle span {
    font-size: 14px;
    padding-right: 8px;
  }

  .main .content .contentTitle .sub {
    top: 10px;
  }

  .main .content .left {
    width: 100%;
    float: none;
  }

  .main .content .left ul {
    margin: 10px 0;
    padding-left: 20px;
  }

  .main .content .left li {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
  }

  .main .content .left .info {
    font-size: 12px;
    line-height: 20px;
    margin: 10px 0;
  }

  .main .content .right {
    width: 100%;
    float: none;
  }

  .main .content .right .contentTitle {
    padding-bottom: 0px;
  }

  .main .content .right .lineTitle {
    padding-top: 10px;
    font-size: 12px;
    line-height: 26px;
  }

  .main .content .right .inputText {
    width: 280px;
    height: 30px;
    padding-left: 6px;
  }

  .main .content .right .textArea {
    width: 274px;
    height: 143px;
    padding: 6px;
  }

  .main .content .right .inputSub {
    font-size: 12px;
    width: 90px;
    height: 34px;
    line-height: 34px;
    margin-top: 14px;
  }

  .main .customer {
    padding-top: 20px;
  }

  .main .customer .title {
    line-height: 24px;
    font-size: 14px;
    padding-bottom: 10px;
  }

  .main .customer .customerContent {
    width: 100%;
    height: 290px;
  }

  .main .customer .customerContent .contents {
    width: 100%;
  }

  .main .customer .customerContent .child {
    width: 100%;
    height: 290px;
  }

  .main .customer .customerContent .child .childContent {
    width: auto;
    height: 160px;
    padding: 12px;
  }

  .main .customer .customerContent .child .childContent p {
    font-size: 12px;
    line-height: 20px;
  }

  .main .customer .customerContent .child .childContent .pointer {
    bottom: -11px;
    height: 11px;
    left: 106px;
  }

  .main .customer .customerContent .child .childFoot {
    height: 80px;
  }

  .main .customer .customerContent .child .childFoot .childIcon {
    height: 80px;
    line-height: 80px;
  }

  .main .customer .customerContent .child .childFoot .childIcon img {
    max-height: 80px;
  }

  .main .customer .customerContent .child .childFoot .childInfo {
    padding-left: 20px;
  }

  .main .customer .customerContent .child .childFoot .childInfo .childTitle {
    font-size: 14px;
    line-height: 24px;
    padding-top: 15px;
  }

  .main .customer .customerContent .child .childFoot .childInfo .childEn {
    line-height: 22px;
    font-size: 12px;
  }

  .main .customer .customerBtn {
    bottom: 54px;
  }

  .main .customer .customerBtn.leftBtn {
    right: 50px;
  }

  .main .customer .customerBtn.rightBtn {
    right: 0px;
  }

  .main .customerLogo {
    padding-top: 34px;
  }

  .main .customerLogo .title {
    line-height: 36px;
    font-size: 18px;
    padding-bottom: 36px;
  }

  .main .customerLogo .customerLogoContent {
    height: 77px;
  }

  .main .customerLogo .customerLogoContent .child {
    width: 90px;
    height: 75px;
    line-height: 75px;
  }

  .main .customerLogo .logoBtn {
    top: 122px;
  }

  .main .customerLogo .logoBtn.leftBtn {
    left: 0px;
  }

  .main .customerLogo .logoBtn.rightBtn {
    right: 0px;
  }
}

@media (min-width: 640px) and (max-width: 1023px ) {
  .main .head {
    padding: 40px 0;
  }

  .main .head .left {
    width: 100%;
    height: auto;
    float: none;
  }

  .main .head .left img {
    width: 100%;
    height: auto;
  }

  .main .head .right {
    width: 100%;
    float: none;
    margin: 10px 0;
  }

  .main .head .right p {
    font-size: 14px;
    line-height: 22px;
  }

  .main .content .contentTitle {
    line-height: 28px;
  }

  .main .content .contentTitle span {
    font-size: 18px;
    padding-right: 12px;
  }

  .main .content .contentTitle .sub {
    top: 14px;
  }

  .main .content .left {
    width: 100%;
    float: none;
  }

  .main .content .left ul {
    margin: 18px 0;
    padding-left: 20px;
  }

  .main .content .left li {
    height: 28px;
    line-height: 28px;
    font-size: 14px;
  }

  .main .content .left .info {
    font-size: 14px;
    line-height: 22px;
    margin: 18px 0;
  }

  .main .content .right {
    width: 100%;
    float: none;
  }

  .main .content .right .contentTitle {
    padding-bottom: 0px;
  }

  .main .content .right .lineTitle {
    padding-top: 14px;
    font-size: 14px;
    line-height: 32px;
  }

  .main .content .right .inputText {
    width: 90%;
    height: 36px;
    padding-left: 12px;
  }

  .main .content .right .textArea {
    width: 90%;
    height: 143px;
    padding: 12px;
  }

  .main .content .right .inputSub {
    font-size: 14px;
    width: 90px;
    height: 34px;
    line-height: 34px;
    margin-top: 14px;
  }

  .main .customer {
    padding-top: 20px;
  }

  .main .customer .title {
    line-height: 36px;
    font-size: 18px;
    padding-bottom: 20px;
  }

  .main .customer .customerContent {
    width: 100%;
    height: 290px;
  }

  .main .customer .customerContent .child {
    width: 600px;
    height: 290px;
  }

  .main .customer .customerContent .child .childContent {
    width: 552px;
    height: 127px;
    padding: 24px;
  }

  .main .customer .customerContent .child .childContent p {
    font-size: 14px;
    line-height: 24px;
  }

  .main .customer .customerContent .child .childContent .pointer {
    bottom: -11px;
    height: 11px;
    left: 106px;
  }

  .main .customer .customerContent .child .childFoot {
    height: 80px;
  }

  .main .customer .customerContent .child .childFoot .childIcon {
    height: 80px;
    line-height: 80px;
  }

  .main .customer .customerContent .child .childFoot .childIcon img {
    max-height: 80px;
  }

  .main .customer .customerContent .child .childFoot .childInfo {
    padding-left: 20px;
  }

  .main .customer .customerContent .child .childFoot .childInfo .childTitle {
    font-size: 14px;
    line-height: 24px;
    padding-top: 15px;
  }

  .main .customer .customerContent .child .childFoot .childInfo .childEn {
    line-height: 22px;
    font-size: 12px;
  }

  .main .customer .customerBtn {
    bottom: 54px;
  }

  .main .customer .customerBtn.leftBtn {
    right: 50px;
  }

  .main .customer .customerBtn.rightBtn {
    right: 0px;
  }

  .main .customerLogo {
    padding-top: 34px;
  }

  .main .customerLogo .title {
    line-height: 36px;
    font-size: 18px;
    padding-bottom: 36px;
  }

  .main .customerLogo .customerLogoContent {
    height: 156px;
  }

  .main .customerLogo .customerLogoContent .child {
    width: 180px;
    height: 130px;
    line-height: 130px;
  }

  .main .customerLogo .logoBtn {
    top: 154px;
  }

  .main .customerLogo .logoBtn.leftBtn {
    left: 0px;
  }

  .main .customerLogo .logoBtn.rightBtn {
    right: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1199px ) {
  .main .head {
    padding: 40px 0;
  }

  .main .head .left {
    width: 480px;
    height: 204px;
  }

  .main .head .right {
    width: 408px;
    margin-right: 20px;
  }

  .main .content .left {
    width: 560px;
  }

  .main .content .right {
    width: 362px;
  }

  .main .content .right .textArea {
    width: 340px;
  }

  .main .customer .title {
    line-height: 36px;
    font-size: 18px;
    padding-bottom: 20px;
  }

  .main .customer .customerContent {
    height: 290px;
  }

  .main .customer .customerContent .child {
    width: 462px;
    height: 236px;
  }

  .main .customer .customerContent .child .childContent {
    width: 424px;
    height: 103px;
    padding: 8px 12px;
  }

  .main .customer .customerContent .child .childContent p {
    font-size: 12px;
    line-height: 18px;
  }

  .main .customer .customerBtn {
    bottom: 54px;
  }

  .main .customer .customerBtn.leftBtn {
    right: 50px;
  }

  .main .customer .customerBtn.rightBtn {
    right: 0px;
  }

  .main .customerLogo {
    padding-top: 34px;
  }

  .main .customerLogo .customerLogoContent {
    height: 156px;
  }

  .main .customerLogo .customerLogoContent .child {
    width: 181px;
    height: 125px;
    line-height: 125px;
  }

  .main .customerLogo .logoBtn {
    top: 150px;
  }

  .main .customerLogo .logoBtn.leftBtn {
    left: 0px;
  }

  .main .customerLogo .logoBtn.rightBtn {
    right: 0px;
  }
}

@media (min-width: 1200px) and (max-width: 1439px ) {
}

@media (min-width: 1440px) and (max-width: 1920px ) {
}

</style>

<script>
import store from "./../../../store";
import config from "./../../../config";
import Header from "@/components/front/Header.vue";
import Footer from "@/components/front/Footer.vue";
import NavigationBar from "@/components/front/NavigationBar.vue";

export default {
  data() {
    return {
      from: {
        name: null,
        email: null,
        title: null,
        content: null,
      },
      languageMap: {}
    };
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    relatedUrl(){
      location.href='/#/about/related';
    },
    contactUsAdd() {
      if (!this.from.name) {
        this.$message.error(this.languageMap['名字不能为空']);
        return;
      }
      if (!this.from.email) {
        this.$message.error(this.languageMap['邮箱不能为空']);
        return;
      }
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!reg.test(this.from.email)) {
        this.$message.error(this.languageMap['邮箱格式正确']);
        return;
      }

      let url = config.url + "FrontController/contactUsAdd.action";
      this.$http.post(url, this.from).then(res => {
        let data = res.data;
        if (data.resultCode == 200) {
          this.$message.success(this.languageMap['已提交']);
          this.from = {
            name: null,
            email: null,
            title: null,
            content: null
          }
        } else {
          this.$message.error(data.message);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    getCookie(name) {  //this.languageMap['获取cookie']
      var arr = null;
      var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      var arr = document.cookie.match(reg);
      if (arr) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    },
    getLanguageMap(e) {
      this.languageMap = e;
      this.$emit('getLanguageMap', e)
    }
  },
  components: {
    Header,
    Footer,
    NavigationBar
  }
};
</script>
